import { Enum } from './enum.class.js';
import EnumItem from './enumItem.class.js';

/**
 * Enum para dias da semana
 * Equivalente ao enum Java DiaDaSemana
 */
class DiaDaSemanaEnum extends Enum {
    constructor() {
        super();
        this.SEGUNDA = new EnumItem(1, 'SEGUNDA');
        this.SEGUNDA.descricao = 'Segunda';
        
        this.TERCA = new EnumItem(2, 'TERCA');
        this.TERCA.descricao = 'Terça';
        
        this.QUARTA = new EnumItem(3, 'QUARTA');
        this.QUARTA.descricao = 'Quarta';
        
        this.QUINTA = new EnumItem(4, 'QUINTA');
        this.QUINTA.descricao = 'Quinta';
        
        this.SEXTA = new EnumItem(5, 'SEXTA');
        this.SEXTA.descricao = 'Sexta';
        
        this.SABADO = new EnumItem(6, 'SABADO');
        this.SABADO.descricao = 'Sábado';
        
        this.DOMINGO = new EnumItem(7, 'DOMINGO');
        this.DOMINGO.descricao = 'Domingo';
    }

    /**
     * Lista todos os dias da semana no formato para select
     * @returns {Array} Array com objetos {value, label}
     */
    listarDiasDaSemana() {
        const dias = [];
        for (let item in this) {
            if (this[item] instanceof EnumItem) {
                dias.push({
                    value: this[item].id,
                    label: this[item].descricao
                });
            }
        }
        return dias;
    }
}

export const diaDaSemanaEnum = new DiaDaSemanaEnum();
